module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-24.6dac5e34.png";